var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-card",
    {
      attrs: {
        elevation: "2",
        outlined: "",
      },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "d-flex align-content-end flex-wrap align-items-end",
        },
        [
          _c(
            "v-container",
            {
              attrs: {
                fluid: "",
              },
            },
            [
              _c(
                "v-row",
                [
                  _c("v-select", {
                    staticClass: "my-2",
                    attrs: {
                      items: _vm.rank,
                      label: "ระดับสมาชิก",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.query.rank,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "rank", $$v)
                      },
                      expression: "query.rank",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "my-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      autocomplete: "off",
                      "hide-details": "",
                      label: "ค้นหาชื่อ",
                    },
                    on: {
                      input: function ($event) {
                        _vm.query.text = $event
                      },
                    },
                    model: {
                      value: _vm.query.text,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "text", $$v)
                      },
                      expression: "query.text",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "my-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      autocomplete: "off",
                      "hide-details": "",
                      label: "ค้นหาชื่อ-เลขบัญชี",
                    },
                    on: {
                      input: function ($event) {
                        _vm.query.bank = $event
                      },
                    },
                    model: {
                      value: _vm.query.bank,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "bank", $$v)
                      },
                      expression: "query.bank",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    staticClass: "my-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      autocomplete: "off",
                      "hide-details": "",
                      label: "ค้นหาip",
                    },
                    on: {
                      input: function ($event) {
                        _vm.query.ip = $event
                      },
                    },
                    model: {
                      value: _vm.query.ip,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "ip", $$v)
                      },
                      expression: "query.ip",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "my-2",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                          },
                          on: {
                            click: _vm.fetchData,
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                              },
                            },
                            [_vm._v("\n              mdi-check\n            ")]
                          ),
                          _vm._v("\n            ค้นหา\n          "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            color: "secondary",
                            outlined: "",
                          },
                          on: {
                            click: _vm.resetFilter,
                          },
                        },
                        [_vm._v("\n            ล้าง\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-card-text", [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "text-white",
                attrs: {
                  color: "red",
                },
              },
              [
                _vm._v("\n        สมาชิกใหม่\n        "),
                _c(
                  "v-chip",
                  {
                    staticClass: "ml-2",
                    attrs: {
                      right: "",
                      color: "white",
                      "x-small": "",
                    },
                    on: {
                      click: _vm.fetchData,
                    },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.newMemberCount) + "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "overflow-x": "scroll",
            },
          },
          [
            _c("v-data-table", {
              staticClass: "elevation-0",
              attrs: {
                "footer-props": _vm.footer,
                headers: _vm.headers,
                items: _vm.items,
                loading: _vm.loading,
                "multi-sort": false,
                options: _vm.options,
                search: _vm.search,
                "server-items-length": _vm.totalItems,
              },
              on: {
                "update:options": function ($event) {
                  _vm.options = $event
                },
                "update:search": function ($event) {
                  _vm.search = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (_ref) {
                    var item = _ref.item
                    return [
                      _c(
                        "p",
                        {
                          staticClass: "ma-0 text-left",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.id) +
                              "#" +
                              _vm._s(item.name) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "text-left text-muted",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.mobile) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.level",
                  fn: function (_ref2) {
                    var item = _ref2.item
                    return [
                      item.level === "user"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "secondary",
                                outlined: "",
                                small: "",
                              },
                            },
                            [_vm._v("\n            user\n          ")]
                          )
                        : item.level === "superuser"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "red",
                                outlined: "",
                                small: "",
                              },
                            },
                            [_vm._v("\n            superuser\n          ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.rank",
                  fn: function (_ref3) {
                    var item = _ref3.item
                    return [
                      item.rank === "user"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "primary",
                                small: "",
                              },
                            },
                            [_vm._v("\n            user\n          ")]
                          )
                        : item.rank === "gold"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "yellow",
                                small: "",
                              },
                            },
                            [_vm._v("\n            gold\n          ")]
                          )
                        : item.rank === "platinum"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "warning",
                                small: "",
                              },
                            },
                            [_vm._v("\n            platinum\n          ")]
                          )
                        : item.rank === "diamond"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "success",
                                small: "",
                              },
                            },
                            [_vm._v("\n            diamond\n          ")]
                          )
                        : item.rank === "superdiamond"
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "success",
                                small: "",
                              },
                            },
                            [_vm._v("\n            superdiamond\n          ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.banks[0]",
                  fn: function (_ref4) {
                    var item = _ref4.item
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                sm: 5,
                                md: 3,
                              },
                            },
                            [
                              _c("v-img", {
                                staticClass: "ma-0",
                                attrs: {
                                  "max-width": 50,
                                  src: item.banks[0].logo_url,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                sm: 7,
                                md: 9,
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "ma-0 text-left text-no-wrap",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.banks[0].account_name) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "pa-0 text-left text-muted",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.banks[0].account_number) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.ip_address",
                  fn: function (_ref5) {
                    var item = _ref5.item
                    return [
                      _c(
                        "p",
                        {
                          staticClass: "mb-0 d-inline-block text-wrap",
                          staticStyle: {
                            "max-width": "100px",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.ip_address) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.created_at",
                  fn: function (_ref6) {
                    var item = _ref6.item
                    return [
                      _c(
                        "p",
                        {
                          staticClass: "ma-0 d-inline-block text-wrap",
                          staticStyle: {
                            "max-width": "100px",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(item.created_at)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _c(
                            "v-chip",
                            {
                              staticClass: "pa-1 m-0 ml-2",
                              attrs: {
                                pill: "",
                                "x-small": "",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$moment(item.created_at).fromNow()
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.remark",
                  fn: function (_ref7) {
                    var item = _ref7.item
                    return [
                      _c("div", [
                        item.count_remark > 0
                          ? _c(
                              "span",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.displayRemark(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "yellow darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-alert")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        item.count_warning > 0
                          ? _c(
                              "span",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.displayWarning(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "orange darken-2",
                                        },
                                      },
                                      [_vm._v("mdi-radioactive")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.detail",
                  fn: function (_ref8) {
                    var item = _ref8.item
                    return [
                      _c(
                        "v-row",
                        {
                          attrs: {
                            "no-gutters": "",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                "align-self": "center",
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.displayDialog(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "green darken-2",
                                            },
                                          },
                                          [_vm._v("mdi-menu")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                "align-self": "center",
                              },
                            },
                            [
                              _vm.role == "admin"
                                ? _c("div", [
                                    item.status != "suspended"
                                      ? _c(
                                          "span",
                                          [
                                            _c("v-switch", {
                                              attrs: {
                                                inset: "",
                                                "input-value": "true",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeStatusMember(
                                                    item.id
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          [
                                            _c("v-switch", {
                                              attrs: {
                                                inset: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeStatusMember(
                                                    item.id
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ])
                                : _c("div", [
                                    item.status != "suspended"
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.suspendMember(
                                                      item.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: "red darken-2",
                                                    },
                                                  },
                                                  [_vm._v("mdi-delete")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.selectedItem
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    width: "600",
                    "max-width": "100vw",
                    "hide-overlay": "",
                  },
                  model: {
                    value: _vm.selectedItem,
                    callback: function ($$v) {
                      _vm.selectedItem = $$v
                    },
                    expression: "selectedItem",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            dark: "",
                            color: "primary",
                          },
                        },
                        [
                          _c("v-card-title", [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-body-1 text-uppercase text-monospace",
                              },
                              [_vm._v(_vm._s(_vm.selectedItem.name))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.selectedItem = false
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        [
                          _c("v-row", [
                            _c(
                              "div",
                              {
                                staticClass: "text-center",
                              },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      color: "primary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                credit:" +
                                        _vm._s(
                                          Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(_vm.amount_credit)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      color: "secondary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                aff:" +
                                        _vm._s(
                                          Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(_vm.amount_aff)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      color: "warning",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                vip:" +
                                        _vm._s(
                                          Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(_vm.amount_vip)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: {
                                      label: "",
                                      color: "info",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                point:" +
                                        _vm._s(
                                          Intl.NumberFormat("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(_vm.amount_point)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            {
                              attrs: {
                                flat: "",
                              },
                            },
                            _vm._l(_vm.menuLinks, function (item) {
                              return _c(
                                "v-list-item",
                                {
                                  key: item.title,
                                  attrs: {
                                    link: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.eventClickMenu(item.action)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(item.title)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            {
                              attrs: {
                                flat: "",
                              },
                            },
                            _vm._l(_vm.menuManages, function (item) {
                              return _c(
                                "v-list-item",
                                {
                                  key: item.title,
                                  attrs: {
                                    link: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.eventClickMenu(item.action)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(item.title)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "blue darken-1",
                                text: "",
                                outlined: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.selectedItem = false
                                },
                              },
                            },
                            [_vm._v("\n            Close\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.depositItem
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    width: "500",
                    "max-width": "100vw",
                    persistent: "",
                  },
                  model: {
                    value: _vm.depositItem,
                    callback: function ($$v) {
                      _vm.depositItem = $$v
                    },
                    expression: "depositItem",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            dark: "",
                            color: "red darken-1",
                          },
                        },
                        [
                          _c("v-card-title", [
                            _c(
                              "span",
                              {
                                staticClass: "text-body-1",
                              },
                              [
                                _vm._v(
                                  "ฝากตรงยูสเซอร์ " +
                                    _vm._s(_vm.depositItem.name)
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-toolbar-items",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    dark: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetDeposit()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "depositForm",
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "my-2",
                                      attrs: {
                                        for: "directdebitAmount",
                                      },
                                    },
                                    [_vm._v("ใส่จำนวนเงิน")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass:
                                          "form-control text-center text-lg",
                                        attrs: {
                                          pattern: "\\d",
                                          required: "",
                                          name: "directdebitAmount",
                                          maxlength: "7",
                                          min: "1",
                                          solo: "",
                                        },
                                        on: {
                                          keypress: function ($event) {
                                            return _vm.validateNumber($event)
                                          },
                                        },
                                        model: {
                                          value: _vm.directdebitAmount,
                                          callback: function ($$v) {
                                            _vm.directdebitAmount = $$v
                                          },
                                          expression: "directdebitAmount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "my-2",
                                      attrs: {
                                        for: "directdebitRemark",
                                      },
                                    },
                                    [_vm._v("หมายเหตุ")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass:
                                          "form-control text-center text-lg",
                                        attrs: {
                                          name: "directdebitRemark",
                                          solo: "",
                                        },
                                        model: {
                                          value: _vm.directdebitRemark,
                                          callback: function ($$v) {
                                            _vm.directdebitRemark = $$v
                                          },
                                          expression: "directdebitRemark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-4",
                                      attrs: {
                                        color: "success",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.directDebit(
                                            _vm.depositItem.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                บันทึก\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "red darken-1",
                                text: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetDeposit()
                                },
                              },
                            },
                            [_vm._v("\n            Close\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                width: "500",
                "max-width": "100vw",
                persistent: "",
              },
              model: {
                value: _vm.remarkItem,
                callback: function ($$v) {
                  _vm.remarkItem = $$v
                },
                expression: "remarkItem",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        dark: "",
                        color: "red darken-1",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c(
                          "span",
                          {
                            staticClass: "text-body-1",
                          },
                          [_vm._v("หมายเหตุ")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                dark: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetRemark()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    {
                      attrs: {
                        subheader: "",
                        "two-line": "",
                      },
                    },
                    [
                      _c(
                        "v-subheader",
                        {
                          attrs: {
                            inset: "",
                          },
                        },
                        [_vm._v("\n            รายการหมายเหตุ\n          ")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.remarkList, function (item) {
                        return _c(
                          "v-list-item",
                          {
                            key: item.id,
                          },
                          [
                            _c(
                              "v-list-item-avatar",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "yellow darken-2",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                mdi-alert\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", {
                                  domProps: {
                                    textContent: _vm._s(item.message),
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-list-item-subtitle", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm
                                          .$moment(item.created_at)
                                          .format("YYYY-MM-DD HH:mm:ss")
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-action",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteRemark(item.id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "red datrken-1",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  mdi-delete\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "remarkForm",
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      solo: "",
                                      name: "remarkDetail",
                                      label: "ใส่หมายเหตุ",
                                    },
                                    model: {
                                      value: _vm.remarkDetail,
                                      callback: function ($$v) {
                                        _vm.remarkDetail = $$v
                                      },
                                      expression: "remarkDetail",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-4",
                              attrs: {
                                color: "success",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addRemark()
                                },
                              },
                            },
                            [_vm._v("\n              บันทึก\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red darken-1",
                            text: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.resetRemark()
                            },
                          },
                        },
                        [_vm._v("\n            Close\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                width: "500",
                "max-width": "100vw",
                persistent: "",
              },
              model: {
                value: _vm.warningItem,
                callback: function ($$v) {
                  _vm.warningItem = $$v
                },
                expression: "warningItem",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        dark: "",
                        color: "red darken-1",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c(
                          "span",
                          {
                            staticClass: "text-body-1",
                          },
                          [_vm._v("แจ้งเตือน")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetWarning()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    {
                      attrs: {
                        subheader: "",
                        "two-line": "",
                      },
                    },
                    [
                      _c(
                        "v-subheader",
                        {
                          attrs: {
                            inset: "",
                          },
                        },
                        [_vm._v("\n            รายการแจ้งเตือน\n          ")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.warningList, function (item) {
                        return _c(
                          "v-list-item",
                          {
                            key: item.id,
                          },
                          [
                            _c(
                              "v-list-item-avatar",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "orange darken-2",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                mdi-radioactive\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", {
                                  domProps: {
                                    textContent: _vm._s(item.message),
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-list-item-subtitle", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm
                                          .$moment(item.created_at)
                                          .format("YYYY-MM-DD HH:mm:ss")
                                      ) +
                                      "\n                "
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.warningTypeName[item.type])
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-action",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteWarning(item.id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "red datrken-1",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  mdi-delete\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "waringForm",
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.warningType,
                                      "item-text": "state",
                                      "item-value": "type",
                                      label: "สถานะใบเตือน",
                                      solo: "",
                                    },
                                    model: {
                                      value: _vm.warningSelect,
                                      callback: function ($$v) {
                                        _vm.warningSelect = $$v
                                      },
                                      expression: "warningSelect",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      solo: "",
                                      name: "remarkDetail",
                                      label: "แจ้งเตือน",
                                    },
                                    model: {
                                      value: _vm.warningDetail,
                                      callback: function ($$v) {
                                        _vm.warningDetail = $$v
                                      },
                                      expression: "warningDetail",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-4",
                              attrs: {
                                color: "success",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addWarning()
                                },
                              },
                            },
                            [_vm._v("\n              บันทึก\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red darken-1",
                            text: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.resetWarning()
                            },
                          },
                        },
                        [_vm._v("\n            Close\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.preload
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    persistent: "",
                    width: "500",
                    "max-width": "100vw",
                  },
                  model: {
                    value: _vm.preload,
                    callback: function ($$v) {
                      _vm.preload = $$v
                    },
                    expression: "preload",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-md-10 mx-lg-auto",
                    },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "text-center",
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 100,
                              width: 10,
                              indeterminate: "",
                              color: "primary",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }